<template>
  <div class="chat_left">
    <div class="chat_left_top">
      <select
        v-model="chat_type_value"
        class="chat_label"
        @change="select_time"
      >
        <option
          v-for="(item,index) in lastmessage_data"
          :key="index"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </div>
    <div
      id="chat_left_people"
      class="chat_left_list overflow_style"
    >
      <ul class="chat_left_people">
        <li
          v-if="chat_list.length===0"
          class="noData"
        >
          <p>暂无数据</p>
        </li>
        <li
          v-for="(item,index) in chat_list"
          :key="index"
          :peer_uid="item.peer_uid"
          :class="{'activebg': item.peer_uid === peer_uid}"
          class="chat_people pointer"
          @click="changemessageFriend(item)"
        >
          <div class="icon_url">
            <img
              :src="item.peer_icon_url ||'https://img.yimutian.com/misc/5996d9cf6ef1434b6a0075bbf9ce8e46-46-46.png' | aspectFit(46, 46)"
              alt
            >
          </div>
          <div class="chat_info">
            <span class="name">{{ item.remark ? item.remark : item.peer_name }}</span>
            <span
              v-if="item.unread_count>0"
              ref="item.peer_id"
              class="count"
            >{{ item.unread_count >
            99 ? '99+' : item.unread_count }}</span>
            <span class="content">{{ item.summary }}</span>
            <span class="time">{{ formatActionTime(item.action_time) }}</span>
          </div>
        </li>
        <div
          v-loading="loadding"
          v-if="hasChatData"
          class="loadding"
        >
          <!-- <mt-spinner type="fading-circle" v-show="loadding"></mt-spinner> -->
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      chat_type_value: 7,
      lastmessage_data: [
        { id: 1, name: '今天' },
        { id: 7, name: '最近7天聊天' },
        { id: 30, name: '最近30天聊天' },
        { id: 31, name: '30天以前聊天' }
      ],
      param: {
        dialog_type: 0, // 0: 普通会话，1:私信, default:0
        page: 0,
        page_size: 20, // default:20
        days: 7 // default:7天
      },
      loadding: false
    }
  },
  computed: {
    ...mapState('chat', [
      'chat_list',
      'peer_uid',
      'customer_id',
      'msgTimestamp',
      'hasChatData',
      'sendTimestamp',
      'chatListTimestamp'
    ])
  },
  watch: {
    msgTimestamp(newValue) {
      this.param.page = 0
      this.chatList(this.param).then(() => {
        this.$store.state.chat.chatListTimestamp = new Date()
      })
    },
    sendTimestamp() {
      this.param.page = 0
      this.chatList(this.param)
    }
  },
  created() {
    this.chatList(this.param)
  },
  mounted() {
    let chatList = document.getElementsByClassName('chat_left_list')[0]
    chatList.addEventListener(
      'scroll',
      () => {
        if (
          chatList.scrollTop + chatList.clientHeight >= chatList.scrollHeight &&
          !this.loadding &&
          this.hasChatData
        ) {
          this.param.page++
          this.loadding = true
          setTimeout(() => {
            this.chatList(this.param).then(() => {
              this.loadding = false
            })
          }, 1000)
        }
      },
      false
    )
  },
  methods: {
    changemessageFriend(item) {
      this.$store.state.chat.peer_uid = item.peer_uid
    },
    ...mapActions('chat', ['chatList']),
    select_time(e) {
      this.param.days = e.target.value
      this.param.page = 0
      this.chatList(this.param)
    },
    formatActionTime(value) {
      let formatTime = this.$options.filters.formatTime
      let date = new Date()
      let oneDayTimeStamp = 24 * 60 * 60 * 1000
      let todayTimestamp = date.getTime() - new Date(2019, 4, 23).getTime()
      if (date.getTime() - value <= todayTimestamp) {
        return formatTime(value, 'hh:mm')
      } else if (
        date.getTime() - value > todayTimestamp &&
        date.getTime() - value < oneDayTimeStamp
      ) {
        return '昨天'
      } else {
        return formatTime(value, 'yyyy/M/d')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loadding {
  margin: 0 auto;
  width: 28px;
  padding: 0.15rem 0;
}
@import '../../assets/contactsList.less';
</style>
